import { render, staticRenderFns } from "./aroundCenterList.vue?vue&type=template&id=9d078c98&scoped=true"
import script from "./aroundCenterList.vue?vue&type=script&lang=js"
export * from "./aroundCenterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d078c98",
  null
  
)

export default component.exports